import React from "react";
import { Button, Modal } from "@telia/teddy";

interface Props {
    open: boolean;
    onClose: () => void;
    title: string;
    message: string;
}

const ExistingSubscriptionNewAccountConflictModal: React.FC<Props> = ({ open, onClose, title, message }) => (
    <Modal open={open} onOpenChange={onClose}>
        <Modal.Overlay>
            <Modal.Content size="sm">
                <Modal.Group variant="title">
                    <Modal.Title as="h3" mt="600">
                        {title}
                    </Modal.Title>
                    <Modal.Close aria-label="lukk" slot="floating" onClick={onClose} />
                </Modal.Group>
                {message}
                <Modal.Group variant="action">
                    <Modal.Close slot="content">
                        <Button variant="secondary" onClick={onClose}>
                            Lukk
                        </Button>
                    </Modal.Close>
                </Modal.Group>
            </Modal.Content>
        </Modal.Overlay>
    </Modal>
);

export default ExistingSubscriptionNewAccountConflictModal;
